/* David Pladen — watches drop-down in the desktop inline menu
 * (sections/dp-header.liquid). Opens on hover with a mouse, on click or
 * Enter/Space otherwise; closes when the pointer leaves the button and the
 * panel, on an outside click, on Escape and when focus leaves both.
 */

if (!customElements.get('dp-dd')) {
  customElements.define(
    'dp-dd',
    class DpDd extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('.dd-b');
        this.panel = document.getElementById(this.dataset.panel);
        if (!this.button || !this.panel) return;
        this.track = this.panel.querySelector('[data-dd-track]');
        this.arrows = Array.from(this.panel.querySelectorAll('[data-dd-dir]'));

        this.button.addEventListener('click', () => this.toggle(!this.isOpen()));

        [this, this.panel].forEach((el) => {
          el.addEventListener('pointerenter', (event) => {
            if (event.pointerType !== 'mouse') return;
            window.clearTimeout(this.closeTimer);
            this.toggle(true);
          });
          el.addEventListener('pointerleave', (event) => {
            if (event.pointerType !== 'mouse') return;
            this.closeTimer = window.setTimeout(() => this.toggle(false), 180);
          });
          el.addEventListener('focusout', (event) => {
            const next = event.relatedTarget;
            if (next && (this.contains(next) || this.panel.contains(next))) return;
            this.toggle(false);
          });
        });

        this.track?.addEventListener('scroll', () => this.updateArrows(), { passive: true });
        this.arrows.forEach((arrow) =>
          arrow.addEventListener('click', () => {
            const step = this.track.clientWidth * 0.8 * parseInt(arrow.dataset.ddDir, 10);
            const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            this.track.scrollBy({ left: step, behavior: reduce ? 'auto' : 'smooth' });
          })
        );

        this.onDocumentClick = (event) => {
          if (this.isOpen() && !this.contains(event.target) && !this.panel.contains(event.target)) this.toggle(false);
        };
        this.onKeydown = (event) => {
          if (event.key !== 'Escape' || !this.isOpen()) return;
          this.toggle(false);
          this.button.focus();
        };
        document.addEventListener('click', this.onDocumentClick);
        document.addEventListener('keydown', this.onKeydown);
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onDocumentClick);
        document.removeEventListener('keydown', this.onKeydown);
      }

      isOpen() {
        return this.button.getAttribute('aria-expanded') === 'true';
      }

      toggle(open) {
        if (open === this.isOpen()) return;
        this.button.setAttribute('aria-expanded', String(open));
        this.panel.hidden = !open;
        if (!open) return;
        this.panel.querySelectorAll('img[loading="lazy"]').forEach((img) => {
          img.loading = 'eager';
        });
        // Close the country list if it is open
        const country = this.closest('dp-header')?.querySelector('.ctry[aria-expanded="true"]');
        if (country) country.click();
        this.updateArrows();
      }

      updateArrows() {
        if (!this.track) return;
        const max = this.track.scrollWidth - this.track.clientWidth;
        const [prev, next] = this.arrows;
        if (prev) {
          prev.hidden = max <= 4;
          prev.disabled = this.track.scrollLeft < 4;
        }
        if (next) {
          next.hidden = max <= 4;
          next.disabled = this.track.scrollLeft >= max - 4;
        }
      }
    }
  );
}
